<template>
    <div>
        <v-card   v-for="publication in publicationsData " :key="publication.id" min-width="100%"
            :class="['my-1',{'productionsm':mdAndDown}, {'production':!mdAndDown},'type'+publication.type ]" >
            <v-card-text class="ma-0">
                <v-row class="ma-0">
                    <v-col  class="d-flex my-0" cols="12" md="2" lg="2" xl="1" >
                        <app-publication-pattern :publication="publication" :bo="bo"></app-publication-pattern>
                    </v-col>
                    <v-col  class="d-flex my-0 pt-0 pb-1" cols="12" md="10" lg="10" xl="11" >
                        <app-publication-content :publication="publication" :bo="bo"></app-publication-content>
                    </v-col>
                </v-row>
            </v-card-text>
        </v-card>
    </div>
</template>
<script>
import publicationPattern from './PublicationPattern.vue';
import publicationContent from './PublicationContent.vue';
import {mapGetters} from 'vuex';
export default {
    props: {
        bo: {type:Boolean,
            default:false
        },
        typeProduction:{type:String},
        publicationsData:{type:Array}

    },
    components:{
        AppPublicationPattern:publicationPattern,
        AppPublicationContent:publicationContent,
    },
    computed: {
        ...mapGetters('header',{
            mdAndDown:'mdAndDown',
        }),
    },
    mounted(){
        this.$emit('progressmore', false);
    }
}
</script>
<style  scoped>
.production{
  border-left-width: 0.7em;
  border-left-style: solid;
}
.productionsm{
  border-left-width:0.3em;
  border-left-style: solid;
}
.type1{
  border-left-color:#5C6BC0
}
.type2{
  border-left-color: rgb(247, 85, 85);
}
.type3{
  border-left-color: green
}
.type4{
  border-left-color: yellow
}
.type5{
  border-left-color: rgb(146, 245, 245)
}
.type6{
  border-left-color: rgb(175, 96, 26)
}
.type7{
  border-left-color: rgb(93, 109, 126 )
}
.type8{
  border-left-color: rgb(100,100,100)
}
</style>



